<!-- Loading skeleton: real header labels + grey placeholder rows, floating in
     with the same cascade the page-entrance plays on data rows. -->
@if (skeletonLoading) {
  <span class="tidy-table-wrapper tidy-table-skeleton">
    <span class="tidy-table-wrapper__content" #tableWrapper>
      <table>
        <thead>
          <tr>
            @for (label of columnslabels; track $index) {
              <th>
                @if (label && label !== 'last-column' && label !== 'Select') {
                  <span>{{ label | translate }}</span>
                }
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of skeletonRows; track $index) {
            <tr>
              @for (label of columnslabels; track $index; let c = $index) {
                <td>
                  @if (label !== 'last-column') {
                    @if (c === 0) {
                      <span class="sk-cell-first">
                        <ion-skeleton-text [animated]="true" class="sk-cell-icon" />
                        <ion-skeleton-text [animated]="true" class="sk-cell-line" />
                      </span>
                    } @else {
                      <ion-skeleton-text [animated]="true" class="sk-cell-line" />
                    }
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </span>
  </span>
}

@if (!skeletonLoading) {
<span class="tidy-table-wrapper" [class.virtual-scrolling]="enableVirtualScrolling" [class.is-empty]="!dataSource?.length" style="overflow: hidden;">
  <span class="tidy-table-wrapper__content" #tableWrapper [class.is-empty]="!dataSource?.length" [style.visibility]="!windowService.isDesktopRes ? 'hidden' : 'visible'" style="overflow-x: hidden; width: 100%; position: relative;">

    <!-- Virtual scrolling container -->
    @if (enableVirtualScrolling) {
      <div class="virtual-scroll-container"
        [style.height.px]="virtualScrollTotalHeight">
        <div class="virtual-scroll-spacer" [style.height.px]="virtualScrollOffsetY"></div>
        <table mat-table matSort [fixedLayout]="false" [dataSource]="tabledataSource" class="mat-elevation-z8 mobile-table" (matSortChange)="emitSortChange($event)" style="table-layout: auto; width: 100%;">
          @for (column of displayedColumns; track column; let i = $index) {
            @if (column === 'Select') {
              <ng-container [matColumnDef]="column">
                <th mat-header-cell *matHeaderCellDef class="select-header">
                  @if (!hideHeaderCheckbox) {
                    <mat-checkbox (change)="$event ? toggleAllRows() : null; this.emitSelectionChange()"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()"
                      [aria-label]="checkboxLabel()"
                      />
                  }
                  @if (hideHeaderCheckbox) {
                    <span>{{ 'Select' | translate }}</span>
                  }
                </th>
                <td class="tidy-table-wrapper__content-cell" mat-cell *matCellDef="let row">
                  <mat-checkbox (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null; this.emitSelectionChange()"
                    [checked]="selection.isSelected(row)"
                    [aria-label]="checkboxLabel(row)" />
                </td>
              </ng-container>
            }
            @if (i == 0 && column !== 'Select') {
              <ng-container [matColumnDef]="column">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                  [disabled]="blockSorting"
                  [style.cursor]="blockSorting ? 'default' : 'pointer'"
                  [tabindex]="blockSorting ? -1 : 0">
                  <span
                    [innerHTML]="(columnslabels[i] ? sanitize(columnslabels[i] | translate) : '')">
                  </span>
                  @if (!blockSorting) {
                    <!-- sort arrow will show as normal -->
                  }
                </th>
                <td class="tidy-table-wrapper__content-cell" mat-cell
                  *matCellDef="let element"
                  (click)="handleCellClick(column, element, $event)"
                  [ngClass]="{'action': element[column].action, 'minColumnWidth': minColumnWidth, 'desktop-min-width': windowService.isDesktopRes}">
                  @if (column !== 'last-column') {
                    <span class="cell-text" (click)="handleSpanClick(column, element, $event)">
                      @if (element[column].selectItems) {
                        <mat-select class="table-inline-select" disableOptionCentering
                          [disabled]="!!element[column].disabled"
                          [value]="element[column].value"
                          (selectionChange)="onSelectChange($event.value, column, element)"
                          (openedChange)="onInlineSelectOpened($event, column, element)"
                          (click)="$event.stopPropagation()"
                          panelClass="table-select-panel">
                          @if (element[column].tagIcon) {
                            <mat-select-trigger>
                              <span class="inline-select-value">
                                <span class="material-icons inline-select-tag" [style.color]="element[column].tagColor || null">{{ element[column].tagIcon }}</span>
                                <span class="inline-select-label">{{ element[column].valueLabel }}</span>
                              </span>
                            </mat-select-trigger>
                          }
                          @if (element[column].selectItems.length > inlineSelectSearchMin) {
                            <mat-option disabled class="table-select-search-option">
                              <div class="dropdown-search" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                                <tidy-image [src]="'assets/svg/search.svg'" class="search-icon" />
                                <input
                                  type="text"
                                  class="search-input"
                                  [placeholder]="'Search' | translate"
                                  [value]="inlineSelectSearch[element.id + '|' + column] || ''"
                                  (input)="onInlineSelectSearch($event, column, element)"
                                  (click)="$event.stopPropagation()"
                                  (mousedown)="$event.stopPropagation()"
                                  (keydown)="$event.stopPropagation()" />
                              </div>
                            </mat-option>
                          }
                          @for (opt of element[column].selectItems | filterSelectItems: inlineSelectSearch[element.id + '|' + column]; track opt.value) {
                            <mat-option [value]="opt.value">
                              @if (opt.tagIcon) {
                                <span class="material-icons inline-select-tag" [style.color]="opt.tagColor || null">{{ opt.tagIcon }}</span>
                              }
                              <span class="inline-select-label">{{ opt.viewValue }}</span>
                            </mat-option>
                          }
                        </mat-select>
                        @if (element[column].icon) {
                          <tidy-image
                            class="table-inline-select-icon"
                            [src]="element[column].icon"
                            [matTooltip]="element[column].iconTooltip || '' | translate" />
                        }
                      } @else {
                        @if (element[column].color && windowService.isDesktopRes) {
                          <tidy-tag
                            [addressId]="element[column].addressId"
                            [color]="element[column].color" />
                        }
                        @if (element[column].icon && !element[column].showIconOnRight && windowService.isDesktopRes) {
                          <tidy-image
                            [src]="element[column].icon"
                            [loading]="preloadImages ? 'eager' : 'lazy'"
                            [style.width]="'18px'"
                            [style.height]="'18px'" />
                        }
                        @if (element[column].initials) {
                          <tidy-initials-icon
                            [fullName]="element[column].value" />
                        }
                        @if (element[column].toggledOn !== undefined) {
                          <tidy-toggle
                            [toggled]="element[column].toggledOn"
                            (toggleChanged)="onToggleChange($event, column, element)" />
                        }
                        @if (!Array.isArray(element[column])) {
                          <span class="no-wrap-text"
                            [matTooltip]="element[column].truncate ? (element[column].value || '' | translate) : ''"
                            [matTooltipDisabled]="!element[column].truncate"
                            matTooltipPosition="above"
                            matTooltipClass="table-truncate-tooltip"
                            [innerHTML]="element[column].value !== null && element[column].value !== undefined ? sanitize(getTruncatedText(element[column].value, element[column].truncate)) : ''"></span>
                        }
                        @if (Array.isArray(element[column])) {
                          <div class="array-cell-container">
                            @for (item of element[column].slice(0, 3); track item) {
                              <div class="array-cell-item" [class.array-cell-item--clickable]="!!item.action" (click)="onArrayItemClick(item, $event)">
                                @if (item.color && windowService.isDesktopRes) {
                                  <tidy-tag
                                    [addressId]="item.addressId"
                                    [color]="item.color" />
                                }
                                @if (item.icon && !item.showIconOnRight && windowService.isDesktopRes) {
                                  <tidy-image
                                    [src]="item.icon"
                                    [loading]="preloadImages ? 'eager' : 'lazy'"
                                    [style.width]="'18px'"
                                    [style.height]="'18px'" />
                                }
                                <span class="no-wrap-text"
                                [matTooltip]="item.truncate ? (item.value || '' | translate) : ''"
                                [matTooltipDisabled]="!item.truncate"
                                matTooltipPosition="above"
                                matTooltipClass="table-truncate-tooltip"
                                [innerHTML]="item.value !== null && item.value !== undefined ? sanitize(getTruncatedText(item.value, item.truncate)) : ''"></span>
                                @if (item.icon && item.showIconOnRight && windowService.isDesktopRes) {
                                  <tidy-image
                                    [src]="item.icon"
                                    [loading]="preloadImages ? 'eager' : 'lazy'"
                                    [style.width]="'18px'"
                                    [style.height]="'18px'" />
                                }
                              </div>
                            }
                            @if (element[column].length > 3 && !isArrayCellExpanded(element, column)) {
                              <div
                                class="array-cell-item more-items clickable-more"
                                (click)="toggleArrayCellExpand(element, column, $event)"
                                [title]="('Click to view all ' | translate) + (element[column].length | translate) + (' items' | translate)">
                                +{{element[column].length - 3}} more
                              </div>
                            }
                            @if (isArrayCellExpanded(element, column)) {
                              @for (item of element[column].slice(3); track item) {
                                <div class="array-cell-item" [class.array-cell-item--clickable]="!!item.action" (click)="onArrayItemClick(item, $event)">
                                  @if (item.color && windowService.isDesktopRes) {
                                    <tidy-tag
                                      [addressId]="item.addressId"
                                      [color]="item.color" />
                                  }
                                  @if (item.icon && !item.showIconOnRight && windowService.isDesktopRes) {
                                    <tidy-image
                                      [src]="item.icon"
                                      [loading]="preloadImages ? 'eager' : 'lazy'"
                                      [style.width]="'18px'"
                                      [style.height]="'18px'" />
                                  }
                                  <span class="no-wrap-text"
                                [matTooltip]="item.truncate ? (item.value || '' | translate) : ''"
                                [matTooltipDisabled]="!item.truncate"
                                matTooltipPosition="above"
                                matTooltipClass="table-truncate-tooltip"
                                [innerHTML]="item.value !== null && item.value !== undefined ? sanitize(getTruncatedText(item.value, item.truncate)) : ''"></span>
                                  @if (item.icon && item.showIconOnRight && windowService.isDesktopRes) {
                                    <tidy-image
                                      [src]="item.icon"
                                      [loading]="preloadImages ? 'eager' : 'lazy'"
                                      [style.width]="'18px'"
                                      [style.height]="'18px'" />
                                  }
                                </div>
                              }
                              <div class="array-cell-item more-items clickable-more" (click)="toggleArrayCellExpand(element, column, $event)">
                                Show less
                              </div>
                            }
                          </div>
                        }
                        @if (element[column].icon && element[column].showIconOnRight && windowService.isDesktopRes) {
                          <tidy-image
                            [src]="element[column].icon"
                            [loading]="preloadImages ? 'eager' : 'lazy'"
                            [style.width]="'18px'"
                            [style.height]="'18px'"
                            [style.margin-left]="'10px'"
                            [ngClass]="element[column].iconClass || ''"
                            [matTooltip]="element[column].iconTooltip || '' | translate"
                            matTooltipPosition="above" />
                        }
                      }
                    </span>
                  }
                </td>
              </ng-container>
            }
            @if (i > 0 && column !== 'Select') {
              <ng-container [matColumnDef]="column">
                @if (column !== 'last-column') {
                  <th mat-header-cell *matHeaderCellDef mat-sort-header
                    [disabled]="blockSorting"
                    [style.cursor]="blockSorting ? 'default' : 'pointer'"
                    [tabindex]="blockSorting ? -1 : 0">
                    <span
                      [innerHTML]="columnslabels[i] ? sanitize(columnslabels[i] | translate) : ''">
                    </span>
                    @if (headerIcons[column]) {
                      <img [src]="headerIcons[column]"
                        class="header-icon-action"
                        (click)="onHeaderIconClick(column, $event)" />
                    }
                    @if (!blockSorting) {
                      <!-- sort arrow will show as normal -->
                    }
                  </th>
                }
                @if (column === 'last-column') {
                  <th mat-header-cell *matHeaderCellDef></th>
                }
                <td class="tidy-table-wrapper__content-cell" mat-cell
                  *matCellDef="let element"
                  (click)="handleCellClick(column, element, $event)"
                  [ngClass]="{'action': element[column].action || element[column].editable, 'minColumnWidth': minColumnWidth, 'desktop-min-width': windowService.isDesktopRes}">
                  @if (column !== 'last-column') {
                    @if (element[column].buttons) {
                      <span class="cell-buttons"
                        [class.cell-buttons--stacked]="element[column].note"
                        (click)="$event.stopPropagation()">
                        @if (element[column].note) {
                          <span class="cell-buttons__note">{{element[column].note}}</span>
                        }
                        <span class="cell-buttons__row">
                          @for (button of element[column].buttons; track button.text) {
                            <tidy-small-button
                              [text]="button.text"
                              [image]="button.image || ''"
                              [colorImage]="!!button.colorImage"
                              [initials]="button.initials || ''"
                              [primary]="!!button.primary"
                              [disabled]="!!button.disabled"
                              (buttonClick)="onCellButtonClick(button)" />
                          }
                        </span>
                      </span>
                    } @else if (!isEditing(element, column)) {
                      <span class="cell-text" (click)="handleSpanClick(column, element, $event)">
                        @if (element[column].selectItems) {
                          <mat-select class="table-inline-select" disableOptionCentering
                            [disabled]="!!element[column].disabled"
                            [value]="element[column].value"
                            (selectionChange)="onSelectChange($event.value, column, element)"
                            (openedChange)="onInlineSelectOpened($event, column, element)"
                            (click)="$event.stopPropagation()"
                            panelClass="table-select-panel">
                            @if (element[column].tagIcon) {
                              <mat-select-trigger>
                                <span class="inline-select-value">
                                  <span class="material-icons inline-select-tag" [style.color]="element[column].tagColor || null">{{ element[column].tagIcon }}</span>
                                  <span class="inline-select-label">{{ element[column].valueLabel }}</span>
                                </span>
                              </mat-select-trigger>
                            }
                            @if (element[column].selectItems.length > inlineSelectSearchMin) {
                              <mat-option disabled class="table-select-search-option">
                                <div class="dropdown-search" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                                  <tidy-image [src]="'assets/svg/search.svg'" class="search-icon" />
                                  <input
                                    type="text"
                                    class="search-input"
                                    [placeholder]="'Search' | translate"
                                    [value]="inlineSelectSearch[element.id + '|' + column] || ''"
                                    (input)="onInlineSelectSearch($event, column, element)"
                                    (click)="$event.stopPropagation()"
                                    (mousedown)="$event.stopPropagation()"
                                    (keydown)="$event.stopPropagation()" />
                                </div>
                              </mat-option>
                            }
                            @for (opt of element[column].selectItems | filterSelectItems: inlineSelectSearch[element.id + '|' + column]; track opt.value) {
                              <mat-option [value]="opt.value">
                                @if (opt.tagIcon) {
                                  <span class="material-icons inline-select-tag" [style.color]="opt.tagColor || null">{{ opt.tagIcon }}</span>
                                }
                                <span class="inline-select-label">{{ opt.viewValue }}</span>
                              </mat-option>
                            }
                          </mat-select>
                          @if (element[column].icon) {
                            <tidy-image
                              class="table-inline-select-icon"
                              [src]="element[column].icon"
                              [matTooltip]="element[column].iconTooltip || '' | translate" />
                          }
                        } @else {
                          @if (element[column].color && windowService.isDesktopRes) {
                            <tidy-tag
                              [addressId]="element[column].addressId"
                              [color]="element[column].color" />
                          }
                          @if (element[column].icon && !element[column].showIconOnRight && windowService.isDesktopRes) {
                            <tidy-image
                              [src]="element[column].icon"
                              [loading]="preloadImages ? 'eager' : 'lazy'"
                              [style.width]="'18px'"
                              [style.height]="'18px'" />
                          }
                          @if (element[column].toggledOn !== undefined) {
                            <tidy-toggle
                              [toggled]="element[column].toggledOn"
                              (toggleChanged)="onToggleChange($event, column, element)" />
                          }
                          @if (!Array.isArray(element[column])) {
                            <span class="no-wrap-text"
                              [matTooltip]="element[column].truncate ? (element[column].value || '' | translate) : ''"
                              [matTooltipDisabled]="!element[column].truncate"
                              matTooltipPosition="above"
                              matTooltipClass="table-truncate-tooltip"
                              [innerHTML]="element[column].value !== null && element[column].value !== undefined ? sanitize(getTruncatedText(element[column].value, element[column].truncate)) : ''"></span>
                          }
                          @if (Array.isArray(element[column])) {
                            <div class="array-cell-container">
                              @for (item of element[column].slice(0, 3); track item) {
                                <div class="array-cell-item" [class.array-cell-item--clickable]="!!item.action" (click)="onArrayItemClick(item, $event)">
                                  @if (item.color && windowService.isDesktopRes) {
                                    <tidy-tag
                                      [addressId]="item.addressId"
                                      [color]="item.color" />
                                  }
                                  @if (item.icon && !item.showIconOnRight && windowService.isDesktopRes) {
                                    <tidy-image
                                      [src]="item.icon"
                                      [loading]="preloadImages ? 'eager' : 'lazy'"
                                      [style.width]="'18px'"
                                      [style.height]="'18px'" />
                                  }
                                  <span class="no-wrap-text"
                                [matTooltip]="item.truncate ? (item.value || '' | translate) : ''"
                                [matTooltipDisabled]="!item.truncate"
                                matTooltipPosition="above"
                                matTooltipClass="table-truncate-tooltip"
                                [innerHTML]="item.value !== null && item.value !== undefined ? sanitize(getTruncatedText(item.value, item.truncate)) : ''"></span>
                                  @if (item.icon && item.showIconOnRight && windowService.isDesktopRes) {
                                    <tidy-image
                                      [src]="item.icon"
                                      [loading]="preloadImages ? 'eager' : 'lazy'"
                                      [style.width]="'18px'"
                                      [style.height]="'18px'" />
                                  }
                                </div>
                              }
                              @if (element[column].length > 3 && !isArrayCellExpanded(element, column)) {
                                <div
                                  class="array-cell-item more-items clickable-more"
                                  (click)="toggleArrayCellExpand(element, column, $event)"
                                  [title]="('Click to view all ' | translate) + (element[column].length | translate) + (' items' | translate)">
                                  +{{element[column].length - 3}} more
                                </div>
                              }
                              @if (isArrayCellExpanded(element, column)) {
                                @for (item of element[column].slice(3); track item) {
                                  <div class="array-cell-item" [class.array-cell-item--clickable]="!!item.action" (click)="onArrayItemClick(item, $event)">
                                    @if (item.color && windowService.isDesktopRes) {
                                      <tidy-tag
                                        [addressId]="item.addressId"
                                        [color]="item.color" />
                                    }
                                    @if (item.icon && !item.showIconOnRight && windowService.isDesktopRes) {
                                      <tidy-image
                                        [src]="item.icon"
                                        [loading]="preloadImages ? 'eager' : 'lazy'"
                                        [style.width]="'18px'"
                                        [style.height]="'18px'" />
                                    }
                                    <span class="no-wrap-text"
                                [matTooltip]="item.truncate ? (item.value || '' | translate) : ''"
                                [matTooltipDisabled]="!item.truncate"
                                matTooltipPosition="above"
                                matTooltipClass="table-truncate-tooltip"
                                [innerHTML]="item.value !== null && item.value !== undefined ? sanitize(getTruncatedText(item.value, item.truncate)) : ''"></span>
                                    @if (item.icon && item.showIconOnRight && windowService.isDesktopRes) {
                                      <tidy-image
                                        [src]="item.icon"
                                        [loading]="preloadImages ? 'eager' : 'lazy'"
                                        [style.width]="'18px'"
                                        [style.height]="'18px'" />
                                    }
                                  </div>
                                }
                                <div class="array-cell-item more-items clickable-more" (click)="toggleArrayCellExpand(element, column, $event)">
                                  Show less
                                </div>
                              }
                            </div>
                          }
                          @if (element[column].icon && element[column].showIconOnRight && windowService.isDesktopRes) {
                            <tidy-image
                              [src]="element[column].icon"
                              [loading]="preloadImages ? 'eager' : 'lazy'"
                              [style.width]="'18px'"
                              [style.height]="'18px'" />
                          }
                        }
                      </span>
                    }
                    @if (isEditing(element, column)) {
                      <span class="cell-content">
                        <input
                          type="number"
                          [(ngModel)]="editValue"
                          (keydown)="onEditKeydown($event)"
                          (blur)="saveEdit()"
                          #editInput
                          class="editable-cell-input"
                          [placeholder]="element[column].value | translate"
                         >
                      </span>
                    }
                  }
                  @if (column === 'last-column') {
                    @if (showArrowIcon) {
                      <span style="cursor: pointer;">
                        <tidy-image
                          [src]="'assets/img/chevron-right.svg'"
                          [loading]="preloadImages ? 'eager' : 'lazy'"
                          class="clickable-row-icon"
                          style="margin-right: 0px" />
                      </span>
                    }
                  }
                </td>
              </ng-container>
            }
          }
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'clickable': allRowIsClickable, 'unread': row?.isUnread}"></tr>
        </table>
        <!-- Loader positioned at bottom of virtual content -->
        @if (isLoading) {
          <div class="virtual-loader" [style.top.px]="(virtualScrollEndIndex * virtualScrollItemHeight) - virtualScrollOffsetY">
            <tidy-loader style="display: flex; justify-content: center; padding: 10px 0; background: var(--tidy-primary-layer-background);" />
          </div>
        }
      </div>
    }

    <!-- Non-virtual scrolling table (fallback) -->
    @if (!enableVirtualScrolling) {
      <table mat-table matSort [fixedLayout]="false" [dataSource]="tabledataSource" class="mat-elevation-z8 mobile-table" (matSortChange)="emitSortChange($event)" style="table-layout: auto; width: 100%;">
        @for (column of displayedColumns; track column; let i = $index) {
          @if (column === 'Select') {
            <ng-container [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef class="select-header">
                @if (!hideHeaderCheckbox) {
                  <mat-checkbox (change)="$event ? toggleAllRows() : null; this.emitSelectionChange()"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                    [aria-label]="checkboxLabel()"
                    />
                }
                @if (hideHeaderCheckbox) {
                  <span>{{ 'Select' | translate }}</span>
                }
              </th>
              <td class="tidy-table-wrapper__content-cell" mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(row) : null; this.emitSelectionChange()"
                  [checked]="selection.isSelected(row)"
                  [aria-label]="checkboxLabel(row)" />
              </td>
            </ng-container>
          }
          @if (i == 0 && column !== 'Select') {
            <ng-container [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                [disabled]="blockSorting"
                [style.cursor]="blockSorting ? 'default' : 'pointer'"
                [tabindex]="blockSorting ? -1 : 0">
                <span
                  [innerHTML]="(columnslabels[i] ? sanitize(columnslabels[i] | translate) : '')">
                </span>
                @if (!blockSorting) {
                  <!-- sort arrow will show as normal -->
                }
              </th>
              <td class="tidy-table-wrapper__content-cell" mat-cell
                *matCellDef="let element"
                (click)="handleCellClick(column, element, $event)"
                [ngClass]="{'action': element[column].action, 'minColumnWidth': minColumnWidth, 'desktop-min-width': windowService.isDesktopRes}">
                @if (column !== 'last-column') {
                  <span class="cell-text">
                    @if (element[column].selectItems) {
                      <mat-select class="table-inline-select" disableOptionCentering
                        [disabled]="!!element[column].disabled"
                        [value]="element[column].value"
                        (selectionChange)="onSelectChange($event.value, column, element)"
                        (openedChange)="onInlineSelectOpened($event, column, element)"
                        (click)="$event.stopPropagation()"
                        panelClass="table-select-panel">
                        @if (element[column].tagIcon) {
                          <mat-select-trigger>
                            <span class="inline-select-value">
                              <span class="material-icons inline-select-tag" [style.color]="element[column].tagColor || null">{{ element[column].tagIcon }}</span>
                              <span class="inline-select-label">{{ element[column].valueLabel }}</span>
                            </span>
                          </mat-select-trigger>
                        }
                        @if (element[column].selectItems.length > inlineSelectSearchMin) {
                          <mat-option disabled class="table-select-search-option">
                            <div class="dropdown-search" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                              <tidy-image [src]="'assets/svg/search.svg'" class="search-icon" />
                              <input
                                type="text"
                                class="search-input"
                                [placeholder]="'Search' | translate"
                                [value]="inlineSelectSearch[element.id + '|' + column] || ''"
                                (input)="onInlineSelectSearch($event, column, element)"
                                (click)="$event.stopPropagation()"
                                (mousedown)="$event.stopPropagation()"
                                (keydown)="$event.stopPropagation()" />
                            </div>
                          </mat-option>
                        }
                        @for (opt of element[column].selectItems | filterSelectItems: inlineSelectSearch[element.id + '|' + column]; track opt.value) {
                          <mat-option [value]="opt.value">
                            @if (opt.tagIcon) {
                              <span class="material-icons inline-select-tag" [style.color]="opt.tagColor || null">{{ opt.tagIcon }}</span>
                            }
                            <span class="inline-select-label">{{ opt.viewValue }}</span>
                          </mat-option>
                        }
                      </mat-select>
                      @if (element[column].icon) {
                        <tidy-image
                          class="table-inline-select-icon"
                          [src]="element[column].icon"
                          [matTooltip]="element[column].iconTooltip || '' | translate" />
                      }
                    } @else {
                      @if (element[column].color) {
                        <tidy-tag
                          [addressId]="element[column].addressId"
                          [color]="element[column].color" />
                      }
                      @if (element[column].icon && !element[column].showIconOnRight && windowService.isDesktopRes) {
                        <tidy-image
                          [src]="element[column].icon"
                          [loading]="preloadImages ? 'eager' : 'lazy'"
                          [style.width]="'18px'"
                          [style.height]="'18px'" />
                      }
                      @if (element[column].initials) {
                        <tidy-initials-icon
                          class="initials-icon"
                          [fullName]="element[column].value" />
                      }
                      @if (element[column].toggledOn !== undefined) {
                        <tidy-toggle
                          [toggled]="element[column].toggledOn"
                          (toggleChanged)="onToggleChange($event, column, element)" />
                      }
                      @if (!Array.isArray(element[column])) {
                        <span class="no-wrap-text truncatable-text"
                          [matTooltip]="element[column].truncate ? (element[column].value || '' | translate) : ''"
                          [matTooltipDisabled]="!element[column].truncate"
                          matTooltipPosition="above"
                          matTooltipClass="table-truncate-tooltip"
                          [innerHTML]="element[column].value !== null && element[column].value !== undefined ? sanitize(getTruncatedText(element[column].value, element[column].truncate)) : ''"></span>
                      }
                      @if (Array.isArray(element[column])) {
                        <div class="array-cell-container">
                          @for (item of element[column].slice(0, 3); track item) {
                            <div class="array-cell-item" [class.array-cell-item--clickable]="!!item.action" (click)="onArrayItemClick(item, $event)">
                              @if (item.color && windowService.isDesktopRes) {
                                <tidy-tag
                                  [addressId]="item.addressId"
                                  [color]="item.color" />
                              }
                              @if (item.icon && !item.showIconOnRight && windowService.isDesktopRes) {
                                <tidy-image
                                  [src]="item.icon"
                                  [loading]="preloadImages ? 'eager' : 'lazy'"
                                  [style.width]="'18px'"
                                  [style.height]="'18px'" />
                              }
                              <span class="no-wrap-text"
                                [matTooltip]="item.truncate ? (item.value || '' | translate) : ''"
                                [matTooltipDisabled]="!item.truncate"
                                matTooltipPosition="above"
                                matTooltipClass="table-truncate-tooltip"
                                [innerHTML]="item.value !== null && item.value !== undefined ? sanitize(getTruncatedText(item.value, item.truncate)) : ''"></span>
                              @if (item.icon && item.showIconOnRight && windowService.isDesktopRes) {
                                <tidy-image
                                  [src]="item.icon"
                                  [loading]="preloadImages ? 'eager' : 'lazy'"
                                  [style.width]="'18px'"
                                  [style.height]="'18px'" />
                              }
                            </div>
                          }
                          @if (element[column].length > 3 && !isArrayCellExpanded(element, column)) {
                            <div
                              class="array-cell-item more-items clickable-more"
                              (click)="toggleArrayCellExpand(element, column, $event)"
                              [title]="('Click to view all ' | translate) + (element[column].length | translate) + (' items' | translate)">
                              +{{element[column].length - 3}} more
                            </div>
                          }
                          @if (isArrayCellExpanded(element, column)) {
                            @for (item of element[column].slice(3); track item) {
                              <div class="array-cell-item" [class.array-cell-item--clickable]="!!item.action" (click)="onArrayItemClick(item, $event)">
                                @if (item.color && windowService.isDesktopRes) {
                                  <tidy-tag
                                    [addressId]="item.addressId"
                                    [color]="item.color" />
                                }
                                @if (item.icon && !item.showIconOnRight && windowService.isDesktopRes) {
                                  <tidy-image
                                    [src]="item.icon"
                                    [loading]="preloadImages ? 'eager' : 'lazy'"
                                    [style.width]="'18px'"
                                    [style.height]="'18px'" />
                                }
                                <span class="no-wrap-text"
                                [matTooltip]="item.truncate ? (item.value || '' | translate) : ''"
                                [matTooltipDisabled]="!item.truncate"
                                matTooltipPosition="above"
                                matTooltipClass="table-truncate-tooltip"
                                [innerHTML]="item.value !== null && item.value !== undefined ? sanitize(getTruncatedText(item.value, item.truncate)) : ''"></span>
                                @if (item.icon && item.showIconOnRight && windowService.isDesktopRes) {
                                  <tidy-image
                                    [src]="item.icon"
                                    [loading]="preloadImages ? 'eager' : 'lazy'"
                                    [style.width]="'18px'"
                                    [style.height]="'18px'" />
                                }
                              </div>
                            }
                            <div class="array-cell-item more-items clickable-more" (click)="toggleArrayCellExpand(element, column, $event)">
                              Show less
                            </div>
                          }
                        </div>
                      }
                      @if (element[column].icon && element[column].showIconOnRight) {
                        <tidy-image
                          [src]="element[column].icon"
                          [loading]="preloadImages ? 'eager' : 'lazy'"
                          [style.width]="'18px'"
                          [style.height]="'18px'"
                          [style.margin-left]="'10px'" />
                      }
                    }
                  </span>
                }
              </td>
            </ng-container>
          }
          @if (i > 0 && column !== 'Select') {
            <ng-container [matColumnDef]="column">
              @if (column !== 'last-column') {
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                  [disabled]="blockSorting"
                  [style.cursor]="blockSorting ? 'default' : 'pointer'"
                  [tabindex]="blockSorting ? -1 : 0">
                  <span
                    [innerHTML]="columnslabels[i] ? sanitize(columnslabels[i] | translate) : ''">
                  </span>
                  @if (headerIcons[column]) {
                    <img [src]="headerIcons[column]"
                      class="header-icon-action"
                      (click)="onHeaderIconClick(column, $event)" />
                  }
                  @if (!blockSorting) {
                    <!-- sort arrow will show as normal -->
                  }
                </th>
              }
              @if (column === 'last-column') {
                <th mat-header-cell *matHeaderCellDef></th>
              }
              <td class="tidy-table-wrapper__content-cell" mat-cell
                *matCellDef="let element"
                (click)="handleCellClick(column, element, $event)"
                [ngClass]="{'action': element[column].action || element[column].editable, 'minColumnWidth': minColumnWidth, 'desktop-min-width': windowService.isDesktopRes}">
                @if (column !== 'last-column') {
                  @if (element[column].buttons) {
                    <span class="cell-buttons"
                      [class.cell-buttons--stacked]="element[column].note"
                      (click)="$event.stopPropagation()">
                      @if (element[column].note) {
                        <span class="cell-buttons__note">{{element[column].note}}</span>
                      }
                      <span class="cell-buttons__row">
                        @for (button of element[column].buttons; track button.text) {
                          <tidy-small-button
                            [text]="button.text"
                            [image]="button.image || ''"
                            [colorImage]="!!button.colorImage"
                            [initials]="button.initials || ''"
                            [primary]="!!button.primary"
                            [disabled]="!!button.disabled"
                            (buttonClick)="onCellButtonClick(button)" />
                        }
                      </span>
                    </span>
                  } @else if (!isEditing(element, column)) {
                    <span class="cell-text">
                      @if (element[column].selectItems) {
                        <mat-select class="table-inline-select" disableOptionCentering
                          [disabled]="!!element[column].disabled"
                          [value]="element[column].value"
                          (selectionChange)="onSelectChange($event.value, column, element)"
                          (openedChange)="onInlineSelectOpened($event, column, element)"
                          (click)="$event.stopPropagation()"
                          panelClass="table-select-panel">
                          @if (element[column].tagIcon) {
                            <mat-select-trigger>
                              <span class="inline-select-value">
                                <span class="material-icons inline-select-tag" [style.color]="element[column].tagColor || null">{{ element[column].tagIcon }}</span>
                                <span class="inline-select-label">{{ element[column].valueLabel }}</span>
                              </span>
                            </mat-select-trigger>
                          }
                          @if (element[column].selectItems.length > inlineSelectSearchMin) {
                            <mat-option disabled class="table-select-search-option">
                              <div class="dropdown-search" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                                <tidy-image [src]="'assets/svg/search.svg'" class="search-icon" />
                                <input
                                  type="text"
                                  class="search-input"
                                  [placeholder]="'Search' | translate"
                                  [value]="inlineSelectSearch[element.id + '|' + column] || ''"
                                  (input)="onInlineSelectSearch($event, column, element)"
                                  (click)="$event.stopPropagation()"
                                  (mousedown)="$event.stopPropagation()"
                                  (keydown)="$event.stopPropagation()" />
                              </div>
                            </mat-option>
                          }
                          @for (opt of element[column].selectItems | filterSelectItems: inlineSelectSearch[element.id + '|' + column]; track opt.value) {
                            <mat-option [value]="opt.value">
                              @if (opt.tagIcon) {
                                <span class="material-icons inline-select-tag" [style.color]="opt.tagColor || null">{{ opt.tagIcon }}</span>
                              }
                              <span class="inline-select-label">{{ opt.viewValue }}</span>
                            </mat-option>
                          }
                        </mat-select>
                        @if (element[column].icon) {
                          <tidy-image
                            class="table-inline-select-icon"
                            [src]="element[column].icon"
                            [matTooltip]="element[column].iconTooltip || '' | translate" />
                        }
                      } @else {
                        @if (element[column].color) {
                          <tidy-tag
                            [addressId]="element[column].addressId"
                            [color]="element[column].color" />
                        }
                        @if (element[column].icon && !element[column].showIconOnRight) {
                          <tidy-image
                            [src]="element[column].icon"
                            [loading]="preloadImages ? 'eager' : 'lazy'"
                            [style.width]="'18px'"
                            [style.height]="'18px'" />
                        }
                        @if (element[column].toggledOn !== undefined) {
                          <tidy-toggle
                            [toggled]="element[column].toggledOn"
                            (toggleChanged)="onToggleChange($event, column, element)" />
                        }
                        @if (!Array.isArray(element[column])) {
                          <span class="no-wrap-text"
                            [matTooltip]="element[column].truncate ? (element[column].value || '' | translate) : ''"
                            [matTooltipDisabled]="!element[column].truncate"
                            matTooltipPosition="above"
                            matTooltipClass="table-truncate-tooltip"
                            [innerHTML]="element[column].value !== null && element[column].value !== undefined ? sanitize(getTruncatedText(element[column].value, element[column].truncate)) : ''"></span>
                        }
                        @if (Array.isArray(element[column])) {
                          <div class="array-cell-container">
                            @for (item of element[column].slice(0, 3); track item) {
                              <div class="array-cell-item" [class.array-cell-item--clickable]="!!item.action" (click)="onArrayItemClick(item, $event)">
                                @if (item.color && windowService.isDesktopRes) {
                                  <tidy-tag
                                    [addressId]="item.addressId"
                                    [color]="item.color" />
                                }
                                @if (item.icon && !item.showIconOnRight && windowService.isDesktopRes) {
                                  <tidy-image
                                    [src]="item.icon"
                                    [loading]="preloadImages ? 'eager' : 'lazy'"
                                    [style.width]="'18px'"
                                    [style.height]="'18px'" />
                                }
                                <span class="no-wrap-text"
                                [matTooltip]="item.truncate ? (item.value || '' | translate) : ''"
                                [matTooltipDisabled]="!item.truncate"
                                matTooltipPosition="above"
                                matTooltipClass="table-truncate-tooltip"
                                [innerHTML]="item.value !== null && item.value !== undefined ? sanitize(getTruncatedText(item.value, item.truncate)) : ''"></span>
                                @if (item.icon && item.showIconOnRight && windowService.isDesktopRes) {
                                  <tidy-image
                                    [src]="item.icon"
                                    [loading]="preloadImages ? 'eager' : 'lazy'"
                                    [style.width]="'18px'"
                                    [style.height]="'18px'" />
                                }
                              </div>
                            }
                            @if (element[column].length > 3 && !isArrayCellExpanded(element, column)) {
                              <div
                                class="array-cell-item more-items clickable-more"
                                (click)="toggleArrayCellExpand(element, column, $event)"
                                [title]="('Click to view all ' | translate) + (element[column].length | translate) + (' items' | translate)">
                                +{{element[column].length - 3}} more
                              </div>
                            }
                            @if (isArrayCellExpanded(element, column)) {
                              @for (item of element[column].slice(3); track item) {
                                <div class="array-cell-item" [class.array-cell-item--clickable]="!!item.action" (click)="onArrayItemClick(item, $event)">
                                  @if (item.color && windowService.isDesktopRes) {
                                    <tidy-tag
                                      [addressId]="item.addressId"
                                      [color]="item.color" />
                                  }
                                  @if (item.icon && !item.showIconOnRight && windowService.isDesktopRes) {
                                    <tidy-image
                                      [src]="item.icon"
                                      [loading]="preloadImages ? 'eager' : 'lazy'"
                                      [style.width]="'18px'"
                                      [style.height]="'18px'" />
                                  }
                                  <span class="no-wrap-text"
                                [matTooltip]="item.truncate ? (item.value || '' | translate) : ''"
                                [matTooltipDisabled]="!item.truncate"
                                matTooltipPosition="above"
                                matTooltipClass="table-truncate-tooltip"
                                [innerHTML]="item.value !== null && item.value !== undefined ? sanitize(getTruncatedText(item.value, item.truncate)) : ''"></span>
                                  @if (item.icon && item.showIconOnRight && windowService.isDesktopRes) {
                                    <tidy-image
                                      [src]="item.icon"
                                      [loading]="preloadImages ? 'eager' : 'lazy'"
                                      [style.width]="'18px'"
                                      [style.height]="'18px'" />
                                  }
                                </div>
                              }
                              <div class="array-cell-item more-items clickable-more" (click)="toggleArrayCellExpand(element, column, $event)">
                                Show less
                              </div>
                            }
                          </div>
                        }
                        @if (element[column].icon && element[column].showIconOnRight && windowService.isDesktopRes) {
                          <tidy-image
                            [src]="element[column].icon"
                            [loading]="preloadImages ? 'eager' : 'lazy'"
                            [style.width]="'18px'"
                            [style.height]="'18px'" />
                        }
                      }
                    </span>
                  }
                  @if (isEditing(element, column)) {
                    <span class="cell-content">
                      <input
                        type="number"
                        [(ngModel)]="editValue"
                        (keydown)="onEditKeydown($event)"
                        (blur)="saveEdit()"
                        #editInput
                        class="editable-cell-input"
                        [placeholder]="element[column].value | translate"
                       >
                    </span>
                  }
                }
                @if (column === 'last-column') {
                  @if (showArrowIcon) {
                    <span style="cursor: pointer;">
                      <tidy-image
                        [src]="'assets/img/chevron-right.svg'"
                        [loading]="preloadImages ? 'eager' : 'lazy'"
                        class="clickable-row-icon"
                        style="margin-right: 0px" />
                    </span>
                  }
                }
              </td>
            </ng-container>
          }
        }
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'clickable': allRowIsClickable, 'unread': row?.isUnread}"></tr>
      </table>
    }

    <!-- Loader for non-virtual scrolling -->
    @if (isLoading && !enableVirtualScrolling) {
      <tidy-loader style="display: flex; justify-content: center; padding: 20px 0; background: var(--tidy-primary-layer-background);" />
    }

    <!-- Spacer to allow scrolling past chatbox -->
    @if (dataSource?.length) {
      <div class="table-bottom-spacer"></div>
    }

    @if (infiniteScroll && scrollWithPage) {
      <ion-infinite-scroll
        threshold="100px"
        (ionInfinite)="onIonInfinite($event)">
        <ion-infinite-scroll-content />
      </ion-infinite-scroll>
    }

  </span>
</span>
}
